import React, { Fragment } from "react"

import { Row } from "./Row"


/**
 * A well formatted Row with a title above, mainly useful for <input...> fields as children
 * 
 * props:
 *      - title     string      title to display above the field
 *      - children  JSX         the field JSX itself
 */
export default function RowWithTitle(props) {

    return (
        <Fragment>
            <Row>
                <h6 style={{ display: "contents" }}>{props.title}</h6>
            </Row><Row>
                {props.children}
            </Row>
            <br />
        </Fragment>
    )
}
